import {FC} from 'react';
import {
  useAudioPanelIsOpen,
  useSubtitlePanelIsOpen,
} from '../../hooks/useTrackContext';
import {AudioPanel} from '../audioPanel/audioPanel';
import {SubtitlePanel} from '../subtitlePanel';
import * as Styles from './panelContainer.styles';

export const PanelContainer: FC = () => {
  const audioPanelIsOpen = useAudioPanelIsOpen();
  const subtitlePanelIsOpen = useSubtitlePanelIsOpen();

  const isOpen = audioPanelIsOpen || subtitlePanelIsOpen;

  return (
    <Styles.Container panelIsOpen={isOpen}>
      <AudioPanel />
      <SubtitlePanel />
    </Styles.Container>
  );
};
